import Image1 from "../../assets/female-icon.png";
import Image2 from "../../assets/male-icon-1.png";
import Image3 from "../../assets/male-icon-2.png";

export const Data = [
    {
      id: 1,
      image: Image2,
      title: "Samuel Godswill",
      description:"A game-changer. They turned our website into a stunning and user-friendly platform. Exceptional attention to detail and great communication.",
    },
    {
      id: 2,
      image: Image1,
      title: "Sonusi Oyinlade",
      description:"A front-end wizard! They revamped our website, and the results were amazing. Superb dedication to user experience and met all deadlines.",
    },
    {
      id: 3,
      image: Image3,
      title: "Arowosoba Abdul-Basit",
      description: "Mujeeb Adewuyi was a game-changer. They turned our website into a stunning and user-friendly platform. Exceptional attention to detail and great communication.",
    },
  ];